import React, { useState, useEffect } from "react"
import { useLocalStorage } from "src/utils/useLocalStorage"
import { useResponsive } from "src/utils/useResponsive"
import PageInfoModal from "src/components/page/PageInfoModal"
import { useSearchParams } from "react-router-dom"

interface PageWithModalProps {
  pageComponent: React.ReactNode
  name: string
}

const PageWithModal: React.FC<PageWithModalProps> = ({ pageComponent, name }) => {
  const { isMobile } = useResponsive()
  const [searchParams] = useSearchParams()
  const skipModal = searchParams.get("skipModal")

  const [dontShowModal, setDontShowModal] = useLocalStorage<boolean>(`exfluency.${name}.dontShowModal`, !!skipModal)
  const [modalDismissed, setModalDismissed] = useState<boolean>(false)

  // Reset modalDismissed when name changes (allows modal to show for new pages)
  useEffect(() => {
    setModalDismissed(false)
  }, [name])

  // Derive showModal state
  const showModal = !dontShowModal && !modalDismissed

  const handleCloseAskModal = () => {
    setModalDismissed(true)
  }

  const handleDontShowAgain = (dontShow: boolean) => {
    setDontShowModal(dontShow)
    setModalDismissed(true)
  }

  return (
    <>
      {(!showModal || !isMobile) && pageComponent}

      <PageInfoModal open={showModal} onClose={handleCloseAskModal} onDontShowAgain={handleDontShowAgain} name={name} />
    </>
  )
}

export default PageWithModal
